module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('icons'), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("\n                Custom Assessment\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "p-reserving__summary"
  }, [_vm._v("\n                Our unique reserving function allows you to perform accurate day one assessments of reserves based on your concluded claims history.\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                Assess and analyse reserves on your entire book of claims. Perform predictive analysis to help with IBNR assessments.\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "u-margin-bottom-20"
  }, [_vm._v("\n                Changes in IBNR requirements following discount rate changes can be performed in seconds — even for 1000s of claims.\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a87adf8a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/reserving/CustomAssessment.vue
// module id = 1786
// module chunks = 0